import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

// import Footer from "../../PortfolioContainer/Footer/Footer";
import imgBack from "../../../src/images/mailz.jpeg";
import load1 from "../../../src/images/load2.gif";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./ContactMe.css";

export default function ContactMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);

  // Sets name, email, and message variables after change in input
  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  const submitForm = async (e) => {
    // Prevent default does not permit form data to be sent if event not handled
    e.preventDefault();
    try {
      let data = {
        name,
        email,
        message,
      };
      setBool(true);

      // For local
      // const res = await axios.post(`/contact`, data);

      // For production
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/contact`,
        data
      );

      // Hard Coded Production Environment Variable
      // const res = await axios.post(
      //   `https://portfolio-website-final.onrender.com/contact`,
      //   data
      // );

      if (name.length === 0 || email.length === 0 || message.length === 0) {
        setBanner(res.data.msg);
        toast.error(res.data.msg);
        setBool(false);
      } else if (res.status === 200) {
        setBanner(res.data.msg);
        toast.success(res.data.msg);
        setBool(false);

        setName("");
        setEmail("");
        setMessage("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main-container fade-in" id={props.id || ""}>
      <ScreenHeading subHeading={"Lets Keep In Touch"} title={"Contact Me"} />
      <div className="central-form">
        <div className="col">
          <h2 className="title">Get In Touch! 📧</h2>{" "}
          {/* Add link components here later */}
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>Reach me directly via email!</h4>
            <img src={imgBack} alt="background" />
          </div>
          {/* when form element is submitted run async event */}
          {/* <form onSubmit={submitForm}>
            <p>{banner}</p>
            <label htmlFor="name">Name</label>
            <input type="text" onChange={handleName} value={name} />

            <label htmlFor="email">Email</label>
            <input type="email" onChange={handleEmail} value={email} />

            <label htmlFor="message">Message</label>
            <textarea type="text" onChange={handleMessage} value={message} />

            <div className="send-btn">
              <button type="submit">
                send
                <i className="fa fa-paper-plane" />
                {bool ? (
                  <b className="load">
                    <img src={load1} alt="loading" />
                  </b>
                ) : (
                  ""
                )}
              </button>
            </div>
          </form> */}
        </div>
        <div className="email-link">
          <p>
            Or reach me directly at:{" "}
            <a href="mailto:andrew.wong8@icloud.com">andrew.wong8@icloud.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}
